import React from 'react';
import { Button, toast } from '@chatui/core';
import { getPhoneCode } from '../../services/ticket';

const PhoneCodeButton = props => {
    const { formName, form } = props;
    const [counter, setCounter] = React.useState(0);

    React.useEffect(() => {
        if (counter > 0) {
            setTimeout(() => {
                setCounter(counter - 1)
            }, 1000);
        }
    }, [counter]);

    const fetchPhoneCode = () => {
        const phone = form.getFieldValue(formName);
        if (counter > 0) {
            toast.show('请稍后操作')
        } else if (!phone) {
            toast.fail('请填写手机号码')
        } else {
            getPhoneCode({ phone: phone })
                .then(res => {
                    if (res.code === 0) {
                        toast.success(res.msg || '发送成功')
                        setCounter(120)
                    } else {
                        toast.fail(res.msg || '发送失败')
                    }
                })
        }
    }
    const secondsToMMSS = (seconds) => {
        var m = Math.floor(seconds / 60);
        var s = seconds % 60;

        return (m < 10 ? '0' : '') + m + ":" + ('0' + s).slice(-2);
    }

    return <Button color="primary" block onClick={() => fetchPhoneCode()}>{counter > 0 ? secondsToMMSS(counter) : '获取验证码'}</Button>
};

export default PhoneCodeButton;
